import {setMetadata} from '../../core/data-source/data-source';
import {HttpCrudDataSource, RestResponseRecord} from '../../core/data-source/http-crud.data-source';
import {fromJson} from '../../core/data-source/json.mapper';
import {httpService, IHttpRequestOptions} from '../../core/services/http.service';
import {LanguageRecord} from '../../records/language.record';

export class UserCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/users';

    async getDispatchers(options?: IHttpRequestOptions): Promise<T[]> {
        return httpService.get(this.apiPath + '/dispatchers', options).then((response: any) => {
            return setMetadata(
                response.data.rows.map((v: any) => fromJson(this.recordClass, v)),
                fromJson(RestResponseRecord, response.data)
            );
        });
    }

    async getlanguages(options?: IHttpRequestOptions): Promise<LanguageRecord[]> {
        return httpService.get(this.apiPath + '/available_languages', options).then((response: any) => {
            return setMetadata(
                response.data.rows.map((v: any) => fromJson(LanguageRecord, v)),
                fromJson(RestResponseRecord, response.data)
            );
        });
    }
}
